export default __webpack_public_path__ + "static/media/list_your_car_mobile.6b4499c8.jpg";